/**
 * Icon with Text Tooltip Handler
 * Handles tooltip display on mobile devices via click/touch
 */

document.addEventListener('DOMContentLoaded', function() {
  const tooltipTriggers = document.querySelectorAll('[data-tooltip]');

  // Detect if device is touch-enabled
  const isTouchDevice = ('ontouchstart' in window) ||
                        (navigator.maxTouchPoints > 0) ||
                        (navigator.msMaxTouchPoints > 0);

  if (!isTouchDevice) {
    // On non-touch devices, use CSS hover (already implemented)
    return;
  }

  // For touch devices, handle click/touch events
  tooltipTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      // Close all other open tooltips
      tooltipTriggers.forEach(otherTrigger => {
        if (otherTrigger !== trigger) {
          otherTrigger.classList.remove('tooltip--is-visible');
        }
      });

      // Toggle current tooltip
      trigger.classList.toggle('tooltip--is-visible');
    });
  });

  // Close tooltip when clicking outside
  document.addEventListener('click', function(e) {
    const clickedInsideTooltip = e.target.closest('[data-tooltip]');

    if (!clickedInsideTooltip) {
      tooltipTriggers.forEach(trigger => {
        trigger.classList.remove('tooltip--is-visible');
      });
    }
  });

  // Close tooltip on scroll
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      tooltipTriggers.forEach(trigger => {
        trigger.classList.remove('tooltip--is-visible');
      });
    }, 100);
  }, { passive: true });

  // Handle ESC key to close tooltips
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      tooltipTriggers.forEach(trigger => {
        trigger.classList.remove('tooltip--is-visible');
      });
    }
  });
});
